import { z } from "zod";

import { PutApiKeyDtoSchema } from "../../../../dtos/api-integrations";
import {
  BaseIntegrationDtoSchema,
  IntegrationNameList,
} from "../../../../dtos/integrations";

export const PutApiIntegrationRequestBodySchema = z.object({
  app: z.enum(IntegrationNameList),
  keys: PutApiKeyDtoSchema.array(),
});

export type PutApiIntegrationRequestBodyType = z.infer<
  typeof PutApiIntegrationRequestBodySchema
>;

export const PutApiIntegrationResponseBodySchema = z.object({
  integration: BaseIntegrationDtoSchema.nullable(),
});

export type PutApiIntegrationResponseBodyType = z.infer<
  typeof PutApiIntegrationResponseBodySchema
>;
